import {
  useIsDesktop,
  useIsWeb,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {View, Text} from 'native-base';
import React from 'react';

import FA5ProIcon from 'react-native-vector-icons/FontAwesome5Pro';
import {useTheme} from 'styled-components/native';

export interface SectionListItemProps {
  icon: string;
  title: string;
  description: string;
}

const SectionListItem: React.FC<SectionListItemProps> = props => {
  const {icon, title, description} = props;
  const theme = useTheme();
  const {silverSand, shuttleGray, tuna} = theme.colors as any;
  const isDesktop = useIsDesktop();
  const isWeb = useIsWeb();

  return (
    <View pb="16px" flexDirection="row">
      <View mt={isWeb ? '3px' : '4px'}>
        <FA5ProIcon name={icon} size={14} color={silverSand} solid />
      </View>
      <View
        ml="8px"
        flexShrink={1} //makes it work for <MD values
      >
        <Text
          fontFamily="heading"
          fontSize="16px"
          fontWeight="700"
          color={shuttleGray}
          pb="12px">
          {title}
        </Text>
        <Text
          fontFamily="heading"
          fontSize="16px"
          color={tuna}
          fontWeight="400">
          {description}
        </Text>
      </View>
    </View>
  );
};

export default SectionListItem;
